import { render, staticRenderFns } from "./DefaultInput.vue?vue&type=template&id=6722b126&"
import script from "./DefaultInput.vue?vue&type=script&lang=js&"
export * from "./DefaultInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports